import React from 'react';

export default () => {
  return <div>Page Not Found</div>;
};



// WEBPACK FOOTER //
// ./src/components/NotFound.js